import { createAPI } from '@common'
// import { createAPI } from '@common/createApis'

export default {
  // 新建任务
  addTasks: config => createAPI('customEncryptApiName-1/0w20ubtlt', 'post', config, {
    e5namespace: 'TaskAdd'
  }),
  // 获取任务
  getTasks: config => createAPI('customEncryptApiName-1/0w20ubtlt', 'get', config),
  // 修改任务
  putTasks: config => createAPI('customEncryptApiName-1/0w20ubtlt', 'put', config, {
    e5namespace: 'TaskAdd'
  }),
  getTasksFolderUserdata: config => createAPI('customEncryptApiName-1/0w20ubtlt0gpmefs0vtfsebub', 'get', config, {
    e5namespace: 'TaskAdd'
  })
}
